import React, { Fragment, useMemo } from "react";
import { Divider, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { Exact, SkillQuestionsQuery } from "@generated/graphql";
import { QueryResult } from "@apollo/client";
import qs from "qs";
import QuestionItem from "./QuestionItem";

interface QuestionListProps {
  isConfirmed?: boolean;
  skillQuery: QueryResult<SkillQuestionsQuery, Exact<{ skillId: string }>>;
}

const QuestionList = ({ isConfirmed, skillQuery }: QuestionListProps) => {
  const { data } = skillQuery;
  const skill = data?.skill;

  const questions = skill?.questions;
  const list = useMemo(
    () => questions?.filter((question) => (isConfirmed ? question.confirmation : !question.confirmation)),
    [isConfirmed, questions]
  );

  return (
    <Box>
      {list?.length ? (
        list.map((item, index) => (
          <Fragment key={`question-${item.id}`}>
            <QuestionItem
              question={item}
              refetch={skillQuery.refetch}
              navigateToQuestionSearch={qs.stringify({ skillId: skill?.id })}
            />
            {list.length > index + 1 && <Divider />}
          </Fragment>
        ))
      ) : (
        <Typography
          variant='body16rg'
          textAlign='center'
          sx={{ display: "block", py: 2.5 }}>
          Вопросов нет
        </Typography>
      )}
    </Box>
  );
};

export default QuestionList;
